import { useState, useEffect } from 'react';
import { P, cardStyle, inputStyle, labelStyle } from '../styles/theme';
import Btn from './Shared/Btn';
import { today } from '../utils/formatters';
import {
  fetchShopHours, toggleShopHourOpen, updateShopHourTime,
  fetchHolidays, insertHoliday, deleteHoliday,
  fetchRetentionDays, saveRetentionDays,
  fetchLunchBreak, saveLunchBreak,
} from '../services/shopService';

const DAYS_KOR = ['일요일','월요일','화요일','수요일','목요일','금요일','토요일'];

export default function ShopSettings() {
  const [hours,          setHours]          = useState([]);
  const [holidays,       setHolidays]       = useState([]);
  const [hForm,          setHForm]          = useState({ start_date: today(), end_date: today(), description: '' });
  const [retentionDays,  setRetentionDays]  = useState('3');
  const [retentionSaved, setRetentionSaved] = useState(false);
  const [lunchBreak,     setLunchBreak]     = useState({ enabled: false, start: '12:00', end: '13:00' });
  const [lunchSaved,     setLunchSaved]     = useState(false);

  useEffect(() => { loadShopHours(); loadHolidays(); loadRetentionDays(); loadLunchBreak(); }, []);

  const loadShopHours    = async () => { setHours(await fetchShopHours()); };
  const loadLunchBreak   = async () => { setLunchBreak(await fetchLunchBreak()); };
  const loadHolidays     = async () => { setHolidays(await fetchHolidays()); };
  const loadRetentionDays = async () => {
    const val = await fetchRetentionDays();
    if (val !== undefined) setRetentionDays(val);
  };

  const handleToggleOpen = async (id, cur) => { await toggleShopHourOpen(id, cur); loadShopHours(); };
  const handleTimeChange = async (id, field, val) => { await updateShopHourTime(id, field, val); loadShopHours(); };

  const handleAddHoliday = async () => {
    if (!hForm.description.trim()) return alert('Please enter a reason for the holiday');
    try { await insertHoliday(hForm); setHForm({ start_date: today(), end_date: today(), description: '' }); loadHolidays(); }
    catch {}
  };

  const handleDeleteHoliday = async (id) => {
    if (!window.confirm('Delete this holiday?')) return;
    await deleteHoliday(id); loadHolidays();
  };

  const handleSaveLunchBreak = async () => {
    try {
      await saveLunchBreak(lunchBreak);
      setLunchSaved(true);
      setTimeout(() => setLunchSaved(false), 2500);
    } catch (err) { alert('저장 실패: ' + err.message); }
  };

  const handleSaveRetentionDays = async () => {
    const val = parseInt(retentionDays, 10);
    if (isNaN(val) || val < 0) return alert('0 이상의 숫자를 입력해주세요.');
    try {
      await saveRetentionDays(val);
      setRetentionSaved(true);
      setTimeout(() => setRetentionSaved(false), 2500);
    } catch (err) { alert('저장 실패: ' + err.message); }
  };

  return (
    <div>
      <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: '26px', color: P.deep, fontWeight: 600, marginBottom: '20px' }}>⚙️ Shop Configuration Hub</h2>
      <div style={cardStyle}>
        <h3 style={{ fontSize: '18px', color: P.deep, marginBottom: '12px' }}>🗓️ 요일별 정기 영업시간 설정</h3>
        {hours.map(h => (
          <div key={h.id} style={{ display: 'grid', gridTemplateColumns: '1.5fr 1fr 2fr 2fr', gap: '10px', alignItems: 'center', padding: '8px 0', borderBottom: `1px solid ${P.bg}` }}>
            <span style={{ fontWeight: 700 }}>{DAYS_KOR[h.day_of_week]}</span>
            <button onClick={() => handleToggleOpen(h.id, h.is_open)} style={{ padding: '4px 8px', borderRadius: '6px', border: 'none', background: h.is_open ? '#EAF5EA' : '#FFF0F0', color: h.is_open ? P.green : P.red, cursor: 'pointer', fontWeight: 700, fontSize: '12px' }}>{h.is_open ? '영업' : '휴무'}</button>
            <input type="time" style={{ ...inputStyle, padding: '4px 6px' }} disabled={!h.is_open} value={h.open_time ? h.open_time.slice(0,5) : '09:00'} onChange={e => handleTimeChange(h.id, 'open_time', e.target.value)} />
            <input type="time" style={{ ...inputStyle, padding: '4px 6px' }} disabled={!h.is_open} value={h.close_time ? h.close_time.slice(0,5) : '18:00'} onChange={e => handleTimeChange(h.id, 'close_time', e.target.value)} />
          </div>
        ))}
      </div>
      <div style={cardStyle}>
        <h3 style={{ fontSize: '18px', color: P.deep, marginBottom: '12px' }}>✈️ 특별 휴무일 지정</h3>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', marginBottom: '10px' }}>
          <div><label style={labelStyle}>휴무 시작일</label><input type="date" style={inputStyle} value={hForm.start_date} onChange={e => setHForm({ ...hForm, start_date: e.target.value, end_date: e.target.value >= hForm.end_date ? e.target.value : hForm.end_date })} /></div>
          <div><label style={labelStyle}>휴무 종료일</label><input type="date" style={inputStyle} min={hForm.start_date} value={hForm.end_date} onChange={e => setHForm({ ...hForm, end_date: e.target.value })} /></div>
        </div>
        <div style={{ marginBottom: '10px' }}><label style={labelStyle}>휴무 사유</label><input style={inputStyle} placeholder="시드니 여행 / 개인 약속" value={hForm.description} onChange={e => setHForm({ ...hForm, description: e.target.value })} /></div>
        <Btn onClick={handleAddHoliday} variant="secondary" style={{ width: '100%', marginBottom: '14px' }}>🚫 휴무 등록</Btn>
        {holidays.map(holiday => (
          <div key={holiday.id} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', fontSize: '13px', borderBottom: `1px solid ${P.bg}` }}>
            <div><span style={{ fontWeight: 700, color: P.red }}>[휴무]</span> {holiday.start_date} ~ {holiday.end_date} <span style={{ marginLeft: '10px', color: P.muted }}>({holiday.description})</span></div>
            <button onClick={() => handleDeleteHoliday(holiday.id)} style={{ background: 'none', border: 'none', color: P.muted, cursor: 'pointer' }}>×</button>
          </div>
        ))}
      </div>
      <div style={cardStyle}>
        <h3 style={{ fontSize: '18px', color: P.deep, marginBottom: '6px' }}>☕ 점심 시간 (Lunch Break)</h3>
        <p style={{ fontSize: '13px', color: P.muted, marginBottom: '16px', lineHeight: '1.6' }}>
          설정한 시간대는 클라이언트 앱에서 예약 불가로 표시됩니다.
        </p>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '14px' }}>
          <span style={{ fontSize: '14px', color: P.text, fontWeight: 600 }}>Lunch Break</span>
          <button onClick={() => setLunchBreak(lb => ({ ...lb, enabled: !lb.enabled }))}
            style={{ padding: '5px 14px', borderRadius: '20px', border: 'none', background: lunchBreak.enabled ? '#EAF5EA' : '#F5F5F5', color: lunchBreak.enabled ? P.green : P.muted, fontWeight: 700, fontSize: '13px', cursor: 'pointer' }}>
            {lunchBreak.enabled ? '● ON' : '○ OFF'}
          </button>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '14px', opacity: lunchBreak.enabled ? 1 : 0.4, pointerEvents: lunchBreak.enabled ? 'auto' : 'none' }}>
          <div>
            <label style={labelStyle}>시작 시간</label>
            <input type="time" style={inputStyle} value={lunchBreak.start}
              onChange={e => setLunchBreak(lb => ({ ...lb, start: e.target.value }))} />
          </div>
          <div>
            <label style={labelStyle}>종료 시간</label>
            <input type="time" style={inputStyle} value={lunchBreak.end}
              onChange={e => setLunchBreak(lb => ({ ...lb, end: e.target.value }))} />
          </div>
        </div>
        <Btn onClick={handleSaveLunchBreak} variant={lunchSaved ? 'secondary' : 'primary'} size="sm">
          {lunchSaved ? '✓ 저장됨' : '저장'}
        </Btn>
        {lunchBreak.enabled && (
          <p style={{ fontSize: '12px', color: P.muted, marginTop: '10px' }}>
            ※ 매일 <strong>{lunchBreak.start} – {lunchBreak.end}</strong> 예약 불가
          </p>
        )}
      </div>

      <div style={cardStyle}>
        <h3 style={{ fontSize: '18px', color: P.deep, marginBottom: '6px' }}>🗑️ 예약 사진 자동 삭제</h3>
        <p style={{ fontSize: '13px', color: P.muted, marginBottom: '16px', lineHeight: '1.6' }}>
          예약일 기준 N일 후 해당 예약의 사진을 자동으로 삭제합니다.<br />
          <strong>0</strong>으로 설정하면 자동 삭제를 비활성화합니다.
        </p>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flex: 1 }}>
            <span style={{ fontSize: '14px', color: P.text, whiteSpace: 'nowrap' }}>예약일 기준</span>
            <input type="number" min="0" max="365" style={{ ...inputStyle, width: '80px', textAlign: 'center' }} value={retentionDays} onChange={e => setRetentionDays(e.target.value)} />
            <span style={{ fontSize: '14px', color: P.text, whiteSpace: 'nowrap' }}>일 후 삭제</span>
          </div>
          <Btn onClick={handleSaveRetentionDays} variant={retentionSaved ? 'secondary' : 'primary'} size="sm">{retentionSaved ? '✓ 저장됨' : '저장'}</Btn>
        </div>
        <p style={{ fontSize: '12px', color: P.muted, marginTop: '10px' }}>
          ※ 현재 설정: 예약일 <strong>+{retentionDays}일</strong> 후 자동 삭제
          {retentionDays === '0' && <span style={{ color: P.amber, marginLeft: '8px' }}>⚠️ 자동 삭제 비활성화됨</span>}
        </p>
      </div>
    </div>
  );
}
